import React from "react";
function Header(props) {
  return (
    <>
<header>
  <div className="container g-0">
    <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.location.reload();
          }}
        >
      <img
        src={props.path}
        alt="ICICI Bank Logo"
        width={252}
        height={50}
        className="img-fluid"
      />
    </a>
  </div>
</header>

    </>
  );
}

export default Header;
